import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
var _info = /*#__PURE__*/new WeakMap();
/**
 * C3DTFeature is a feature of a 3DTiles
 *
 * @class      C3DTFeature
 * @param {number} tileId - tile id
 * @param {number} batchId - batch id
 * @param {Array<{start:number,count:number}>} groups - groups in geometry.attributes matching batchId
 * @param {object} info - info in the batchTable
 * @param {object} [userData={}] - some userData
 * @property {number} tileId - tile id
 * @property {number} batchId - batch id
 * @property {Array<{start:number,count:number}>} groups - groups in geometry.attributes matching batchId
 * @property {object} info - info in the batchTable
 * @property {object} [userData={}] - some userData
 */
var C3DTFeature = /*#__PURE__*/function () {
  function C3DTFeature(tileId, batchId, groups, info) {
    var userData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    _classCallCheck(this, C3DTFeature);
    _classPrivateFieldInitSpec(this, _info, {
      writable: true,
      value: void 0
    });
    /** @type {number} */
    this.tileId = tileId;

    /** @type {number} */
    this.batchId = batchId;

    /** @type {Array<{start:number,count:number}>} */
    this.groups = groups;

    /** @type {object} */
    this.userData = userData;

    /** @type {object} */
    _classPrivateFieldSet(this, _info, info);
  }

  /**
   *
   * @returns {object} - batchTable info
   */
  _createClass(C3DTFeature, [{
    key: "getInfo",
    value: function getInfo() {
      return _classPrivateFieldGet(this, _info);
    }
  }]);
  return C3DTFeature;
}();
export default C3DTFeature;